import { footerData } from '@/mocks/home';

export default function Footer() {
  const { siteName, description, quickLinks } = footerData;

  return (
    <footer id="footer" className="bg-foreground-900 text-foreground-100 pt-12 md:pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="lg:col-span-2">
            <h2 className="text-lg font-heading font-bold text-white mb-4">{siteName}</h2>
            <p className="text-sm text-foreground-300 leading-relaxed max-w-md">
              {description}
            </p>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold text-white mb-4">快速导航</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold text-white mb-4">合作伙伴</h3>
            <p className="text-sm text-foreground-400 leading-relaxed">
              更多精彩内容持续更新中
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 {siteName}. 本站内容仅供学习交流，影片版权归原作者所有。
          </p>
        </div>
      </div>
    </footer>
  );
}